<template>
    <li
        v-show="isFolder"
        :class="{ 'is-root': isRoot, 'is-leaf': isLeaf, 'is-folder': isFolder }"
    >

        <!-- TREE TARGET -->
        <div class="tree-target"
             @click="select">

                <!-- [+][-] -->
                <i v-if="!isLeaf"
                    class="icon-toggle fa"
                    :class="{ 'fa-minus-square-o': open, 'fa-plus-square-o': !open }"
                    @click.stop="toggleFolder">
                </i>

                <!-- ICON -->
                <i :class="iconClass()"></i>

                <!-- TEXT -->
                <span
                    class="text"
                    :class="{ active: isActive(model.path) }"
                    v-text="model.name">
                </span>
        </div>

        <!-- TREE VIEW DIRECTORY -->
        <!-- v-if="isFolder"
            v-show="open" show will only work if the node has 'open' on it -->
        <ul
            v-show="open"
            :data-path="model.path">

            <TreeViewDirectory
                v-for="(model, index) in model.children"
                :active="active"
                :event-bus="eventBus"
                :key="model.path"
                :model="model"
            />
        </ul>

    </li>
</template>

<script>
    import { mapActions } from 'vuex';
    import TreeViewDirectory from './FileSystemTreeViewDirectory';

    export default {
        name: 'TreeViewDirectory', // was Directory, issue?
        props: {
            active: String,
            eventBus: Object,
            model: Object,
        },
        components: {
            TreeViewDirectory,
        },
        data(){
            return {
                open: false
            }
        },
        //------------------------------------------------------------
        // COMPUTED
        //------------------------------------------------------------

        computed: {
            isFolder() {
                return this.model.children || false; // children can be 'false'
            },
            isLeaf() {
                // return !this.model.children || this.model.children.length < 1;
                return this.model.isLeaf; // tricky one, need check for no more folders in children
            },
            isRoot() {
                return this.model.path == '/';
            },
        },
        //------------------------------------------------------------
        // CREATED
        //------------------------------------------------------------

        created() {
            // console.log(this.model)
            this.open = this.model.open; // one time on INIT: all node.open='true' will open
        },
        //------------------------------------------------------------
        // METHODS
        //------------------------------------------------------------

        methods: {
            select() {
                this.eventBus.$emit('select-directory', this.model); // pass node to open in table
            },
            toggleFolder() {
                if (this.isFolder) {
                    this.open = !this.open;
                }
            },
            isActive(path) {
                return this.active === path;
            },
            iconClass() {
                const defaultIcon = this.model.children ? ['fa fa-folder', 'fa fa-folder-open'] : 'fa file-o';
                const icon = this.model.icon || defaultIcon;
                const isActive = this.isActive(this.model.path);

                // if multiple items are defined
                if (Array.isArray(icon)) {
                    return icon.length && isActive ? icon[1] : icon[0]; // active uses other icon
                }
                return icon; // return normal icon
            }
        }
    }
</script>

<!-- <i v-if="!isLeaf"
    class="leaf-toggle-icon"
    :class="{ 'is-minus': open, 'is-plus': !open }"
    @click.stop="toggle">
</i> -->

<style lang="scss" scoped>

    //------------------------------------------------------------
    // UL, LI
    //------------------------------------------------------------

    ul {
        list-style: none; // [RESET]
        padding: 0; // [RESET]
        margin: 0; // [RESET]
    }

    li {
        font-size: rem-calc(14); // [LOCKED]
        white-space: nowrap; // [LOCKED]
    }

    //------------------------------------------------------------
    // TREE TARGET (Anchor Equiv)
    //------------------------------------------------------------

    .tree-target {
        position: relative; // [LOCKED] - for the line
        top: rem-calc(12); // [LOCKED] - eyeballing
        background: #f6f6f2; // illusion
        padding: 0 5px; // slight space from horizontal line
    }

    .tree-target .text {
        margin-right: 8px; // [LOCKED] - comfortable UX when scrolling horizontal pane
    }

    //------------------------------------------------------------
    // LINES + INDENTATION
    //------------------------------------------------------------

    $indent-left: 12px; // [LOCKED] - needs pixels for precision

    // vertical line
    ul, li {
        padding-left: $indent-left;
    }

    // horizontal line
    li .tree-target:after {
        content: "";
        position: absolute;
        top: 8px;
        left: -12px;
        width: 12px;
        height: 1px;
    }

    li ul {
        margin-left: -$indent-left;
        padding-left: $indent-left * 2;
    }

    ul li:last-child > ul {
       margin-left: -($indent-left + 1); // for border overlap
    }

    // ******** THEME

    .theme-95 {
        li {
            border-left: 1px solid rgba(black, 0.15);
        }

        // horizontal line
        li .tree-target:after {
            background: #d1d1ce;
        }

        ul li:last-child > ul {
           border-left: 1px solid #f6f6f2; // illusion
        }
    }

    .theme-os {
        li {
            border-left: 1px solid black;
        }

        // horizontal line
        li .tree-target:after {
            background: black;
        }

        ul li:last-child > ul {
           border-left: 1px solid black; // illusion
        }
    }

    //------------------------------------------------------------
    // ROOT
    // Hide root node: it's for schema only (not user)
    //------------------------------------------------------------

    .tree-view-list > li.is-root > .tree-target > .icon-toggle, // [+][-]
    .tree-view-list > li.is-root > ul > li > .tree-target > .icon-toggle, // [+][-]
    .tree-view-list > li.is-root > .tree-target:after, // |
    .tree-view-list > li.is-root > ul > li > .tree-target:after, // |
    .tree-view-list > li.is-root > .tree-target { // 'root'
        display: none;
    }

    .tree-view-list > li.is-root,
    .tree-view-list > li.is-root > ul,
    .tree-view-list > li.is-root > ul > li {
        padding-left: 0; // excluding root node leftovers
        margin-left: 0;
        border-left: 0;
    }

    // //------------------------------------------------------------
    // // FOLDER (ADHOC) - now in app file system
    // //------------------------------------------------------------

    // .fa {
        // color: #808080;
    // }

    // .fa-folder,
    // .fa-folder-open {
    //     // opacity: 0;
    //     color: #f5d67c;
    //     // font-size: rem-calc(18);
    //     text-shadow: -0.5px 0.5px 1px rgba(black, 0.4);
    //     z-index: 1;
    //     position: relative;
    // }

    //------------------------------------------------------------
    // [+][-]
    //------------------------------------------------------------

    .fa-plus-square-o,
    .fa-minus-square-o {
        position: absolute;
        top: 4px;
        left: -16px;
        font-size: 10px; //rem-calc(10);
        z-index: 1;
    }

    // .leaf-toggle-icon {
    //     position: absolute;
    //     top: 5px;
    //     left: -16px;
    //     width: 8px;
    //     height: 8px;
    //     border: 1px solid lighten(#333, 20%);
    //     background: white; //#f6f6f2;
    //     font-size: 10px; //rem-calc(10);
    //     z-index: 1;

    //     &:after {
    //         content: "+";
    //         position: absolute;
    //         top: 4px;
    //         left: 0;
    //         font-size: 9px;
    //         font-style: normal;
    //         line-height: 0;
    //     }
    // }

    // ******** THEME

    .theme-95 {
        .fa.icon-toggle {
            background: #f6f6f2;
            color: darken(#d1d1ce, 60%);
        }
    }

    .theme-os {
        .fa-plus-square-o,
        .fa-minus-square-o {
            background: #303030;
            color: white; //darken(#d1d1ce, 100%);
        }
    }

    //------------------------------------------------------------
    // ACTIVE
    //------------------------------------------------------------

    .text {
        display: inline-block; // [LOCKED] - fixes weird line-height bug
        padding: 0 3px;
    }

    .text.active {
        // padding: 0 3px;
        background: #364847; // TODO: variable? //#050080; //#3ba776; //rgba(black, 0.5);
        color: #f6f6f2;
    }

</style>